export {PrefabBase}						from "./prefabs/PrefabBase";
export {PrimitiveCapsulePrefab}			from "./prefabs/PrimitiveCapsulePrefab";
export {PrimitiveConePrefab}				from "./prefabs/PrimitiveConePrefab";
export {PrimitiveCubePrefab}				from "./prefabs/PrimitiveCubePrefab";
export {PrimitiveCylinderPrefab}			from "./prefabs/PrimitiveCylinderPrefab";
export {PrimitivePlanePrefab}			from "./prefabs/PrimitivePlanePrefab";
export {PrimitivePolygonPrefab}			from "./prefabs/PrimitivePolygonPrefab";
export {PrimitivePrefabBase}				from "./prefabs/PrimitivePrefabBase";
export {PrimitiveSpherePrefab}			from "./prefabs/PrimitiveSpherePrefab";
export {PrimitiveTorusPrefab}			from "./prefabs/PrimitiveTorusPrefab";